import { render } from "./button-parent.vue?vue&type=template&id=1215c4e3"
import script from "./button-parent.vue?vue&type=script&lang=js"
export * from "./button-parent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__